let config = {
	request: {
		// #ifdef H5
		baseUrl: window.location.protocol + "//" + window.location.host+"/api",
		// #endif
		// #ifdef MP || APP-PLUS || APP-PLUS
		baseUrl: "https://b2cv3.a3-mall.com/api",
		// #endif
		header: {
			'content-type': 'application/json'
		},
		timeout: 60000,
		dataType: "json",
		responseType: "text"
	}
}

if(process.env.NODE_ENV === "development"){
	config.request.baseUrl = "http://shop.cusco.et.top:8888/api";
}

export default config;